import { PaginatedDtoSchema } from "@core/data/dto/paginated.dto";
import * as z from "zod";

const CampaignNotebookDtoSchema = z.object({
    id: z.number(),
});
const CampaignStationDtoSchema = z.object({
    id: z.number(),
    name: z.string().trim(),
});
const CropTypeDtoSchema = z.object({
    id: z.number(),
    code: z.string().trim(),
});

export const CampaignDtoSchema = z.object({
    id: z.number(),
    name: z.string().trim(),
    start_date: z.string().trim(),
    end_date: z.string().trim(),
    crop_type: CropTypeDtoSchema,
    stations: z.array(CampaignStationDtoSchema),
    notebook: CampaignNotebookDtoSchema,
});
export type CampaignDto = z.output<typeof CampaignDtoSchema>;

export const CampaignsDtoSchema = z
    .object({
        results: z.array(CampaignDtoSchema),
        pagination: PaginatedDtoSchema,
    })
    .readonly();
export type CampaignsDto = z.output<typeof CampaignsDtoSchema>;

export interface CampaignCreateBody {
    campaign: {
        name: string;
        start_date: string;
        end_date: string;
        crop_type_id: number;
        station_ids: number[];
    };
}
export interface CampaignUpdateBody {
    campaign: {
        name: string;
        start_date: string;
        end_date: string;
        crop_type_id: number;
        station_ids: number[];
    };
}
